<template>
  <div class="order-examine-popup">
    <el-dialog title="维修完成"  :close-on-click-modal="false" :visible.sync="visible" :width="'30%'" center>
      <el-form :model="dataForm" ref="dataForm" size="small" label-width="120px">
        <el-row :gutter="50">
          <el-col :span="24">
            <el-form-item label="维修完成时间" prop="successTime" :rules="[{ required: true, message: '选择完成时间', trigger: 'change' }]">
              <el-date-picker
                v-model="dataForm.successTime"
                type="datetime"
                default-time="12:00:00"
                format="yyyy-MM-dd HH:mm"
                value-format="yyyy-MM-dd HH:mm"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="confirm">确 认</el-button>
        <el-button type="primary" @click="visible = false">返 回</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        status: 1,
        successTime: null,
        id: null
      }
    }
  },
  methods: {
    init (row) {
      this.visible = true
      this.dataForm.id = row.id
    },
    confirm () {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/vehicleRepair/updateSelect`),
            method: 'POST',
            data: {
              id: this.dataForm.id,
              successTime: this.dataForm.successTime,
              status: this.dataForm.status
            }
          }).then(({ data }) => {
            this.$message({
              message: '操作成功',
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.visible = false
                this.$emit('refreshDataList')
              }
            })
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
